/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useEffect, useRef, useState } from "react";
import { Menu, MenuDivider, MenuItem, MenuList, MenuPopover, MenuTrigger, PositioningImperativeRef, PositioningVirtualElement } from "@fluentui/react-components";
import { CustomDataTableAction } from "./CustomDataTable";

type CustomDataTableContextMenuProps<T> = {
    item?: T;
    children?: ReactElement<any>;
    open?: boolean;
    onOpenChange?: (isOpen: boolean) => void;
    menuPosition?: { x: number, y: number };
    actions?: CustomDataTableAction<T>[];
}
export const CustomDataTableContextMenu = <T,>(props: CustomDataTableContextMenuProps<T>) => {

    const { item, children, open, onOpenChange, menuPosition, actions } = props;

    //Hooks
    const positioningRef = useRef<PositioningImperativeRef>(null);

    //State
    const [internalOpen, setInternalOpen] = useState<boolean>(false);

    //Effects
    useEffect(() => {
        const getRect = (x = 0, y = 0) => {
            return () => ({
                width: 0,
                height: 0,
                top: y,
                right: x,
                bottom: y,
                left: x,
                x,
                y,
            });
        };
        const virtualElement: PositioningVirtualElement = {
            getBoundingClientRect: getRect(menuPosition?.x, menuPosition?.y),
        };
        positioningRef.current?.setTarget(virtualElement);
    }, [menuPosition]);

    useEffect(() => {
        const dialogsOpen = new Map<string, boolean>();
        actions?.forEach((act) => {
            dialogsOpen.set(act?.label, false);
        });
        // setDialogOpen(dialogsOpen);
    }, [actions]);

    return (
        <>
            <Menu open={open ?? internalOpen}
                onOpenChange={(_, data) => { onOpenChange ? onOpenChange(data.open) : setInternalOpen(data.open) }}
                hasIcons
                positioning={{ positioningRef: menuPosition ? positioningRef : undefined, position: 'below', align: 'end' }}
            >
                <MenuTrigger disableButtonEnhancement>
                    {children}
                </MenuTrigger>
                <MenuPopover>
                    <MenuList>
                        <>
                            {actions?.map((act, index) => (
                                <React.Fragment key={index}>
                                    {act.divider && (
                                        <MenuDivider />
                                    )}
                                    {!act.divider && (!act.canAccess || (!!act.canAccess && act.canAccess(item))) && (
                                        <>
                                            <MenuItem
                                                icon={typeof act?.icon === 'function' ? act?.icon(item!) : (act?.icon || null)}
                                                aria-label={act.ariaLabel}
                                                onClick={(e: any) => {
                                                    e.stopPropagation();

                                                    !!act.onMenuClick && act.onMenuClick(item!, e);
                                                }}
                                                data-testid={`custom-data-table-context-menu-item-${act.label}`}
                                            >
                                                {act.label}
                                            </MenuItem>
                                        </>
                                    )}
                                </React.Fragment>
                            ))}
                        </>
                    </MenuList>
                </MenuPopover>
            </Menu>
        </>
    )
}